import Image from "next/image";
import React, { Component } from "react";

class StepCongratulation extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        {" "}
        <div className="congratulation__screen">
          <div className="congratulations__screen__image">
            {" "}
            <Image
              src="/static/images/congatulation.svg"
              alt="Find a co-founder today"
              height={400}
              width={400}
              priority={true}
            />
          </div>
        </div>
      </>
    );
  }
}

export default StepCongratulation;
